import React from "react";
import { useTheme } from "@hooks/useTheme";

const CustomCheckbox = ({
  id,
  checked,
  onChange,
  label,
  disabled = false,
  className = "",
  labelClassName = "",
  size = "md", // "sm", "md", "lg"
  ...props
}) => {
  const { colors } = useTheme();

  const getSizeClasses = () => {
    switch (size) {
      case "sm":
        return "w-4 h-4";
      case "lg":
        return "w-6 h-6";
      case "md":
      default:
        return "w-5 h-5";
    }
  };

  const getIconSize = () => {
    switch (size) {
      case "sm":
        return "w-2.5 h-2.5";
      case "lg":
        return "w-4 h-4";
      case "md":
      default:
        return "w-3 h-3";
    }
  };

  return (
    <label
      className={`flex items-center max-w-max ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'} ${className}`}
      onClick={(e) => e.stopPropagation()}
    >
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={onChange}
        className="peer hidden"
        disabled={disabled}
        {...props}
      />

      <div
        className={`${getSizeClasses()} flex items-center justify-center border rounded-sm 
          transition duration-200 ease-in-out
          ${checked ? `${colors.bgActivePrimary} ${colors.borderPrimary}` : `${colors.borderPrimary} ${colors.bgSecondary}`}
          ${disabled ? 'opacity-50' : `${colors.hoverCheckbox}`}`}
      >
        {checked && (
          <svg
            className={`${getIconSize()} ${colors.textOnPrimary}`}
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M16.707 5.293a1 1 0 00-1.414 0L8 12.586 4.707 9.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l8-8a1 1 0 000-1.414z"
              clipRule="evenodd"
            />
          </svg>
        )}
      </div>

      {label && (
        <span className={`ml-3 ${colors.textPrimary} text-sm ${labelClassName}`}>
          {label}
        </span>
      )}
    </label>
  );
};

export default CustomCheckbox; 